import jwtDecode from 'jwt-decode';

function setData(storage, key, data) {
  storage.setItem(key, JSON.stringify(data));
}

function getData(storage, key) {
  const data = storage.getItem(key);

  if (data !== null) {
    return JSON.parse(data);
  }

  return null;
}

export class SecurityHelper {
  constructor({ storage = window.localStorage, key = 'developer-session' } = {}) {
    this.storage = storage;
    this.key = key;

    this.getTokenHeaders = this.getTokenHeaders.bind(this);
    this.getApiKeyHeaders = this.getApiKeyHeaders.bind(this);
  }

  token(data = null) {
    if (data) {
      setData(this.storage, `${this.key}-token`, data);
    }

    const token = getData(this.storage, `${this.key}-token`);

    if (token === null) {
      return null;
    }

    return token;
  }

  apiKey(data = null) {
    if (data) {
      setData(this.storage, `${this.key}-apiKey`, data);
    }

    const apiKey = getData(this.storage, `${this.key}-apiKey`);

    if (apiKey === null) {
      return null;
    }

    return apiKey;
  }

  user(data = null) {
    if (data) {
      setData(this.storage, `${this.key}-user`, data);
    }

    const user = getData(this.storage, `${this.key}-user`);

    if (user === null) {
      return {};
    }

    return user;
  }

  clearData() {
    this.storage.clear();
  }

  isLoggedIn() {
    const token = this.token();

    // No account
    if (token === null) {
      return false;
    }

    const jwt = jwtDecode(token);

    // Not expired
    if (jwt.exp > Date.now() / 1000) {
      return true;
    }

    // Expired
    this.clearData();

    return false;
  }

  getAuthHeader() {
    return `Bearer ${this.token()}`;
  }

  getTokenHeaders(headers) {
    return { ...headers, Authorization: this.getAuthHeader() };
  }

  getApiKeyHeaders(headers) {
    return { ...headers, apikey: this.apiKey() };
  }
}

export default new SecurityHelper({});
